import { ApplyRewardScreen } from '../../../../screens';

// ─────────────────────────────────────────────────────────────────────────────

export default function Page() {
  return <ApplyRewardScreen />;
}
